import { call, put, select, StrictEffect, takeEvery } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";
import { ExtractionSummary } from "@/jenesys-types/jenesys-entities/config";

import { performDataAction } from "@/services/api";
import { selectActiveCompanyId } from "@/store/features/companies/companies";

import {
  clientDashboardFailure,
  clientDashboardSuccess,
  clientTotalDashboardFailure,
  clientTotalDashboardSuccess,
  loadClientDashboard,
  LoadClientDashboardAction,
  loadClientTotalDashboard
} from "./clientDashboard";

export function* loadClientDashboardSaga(
  action: LoadClientDashboardAction
): Generator<StrictEffect, void, any> {
  const { clientId, dateRange } = action.payload;
  const companyId = yield select(selectActiveCompanyId);

  try {
    const clientDashboardResponse: ExtractionSummary = yield call(
      performDataAction,
      DataType.Summary,
      "getSummaryInRange",
      {
        clientId: clientId || companyId,
        before: dateRange.before,
        after: dateRange.after
      }
    );
    yield put(clientDashboardSuccess(clientDashboardResponse));
  } catch (error) {
    yield put(clientDashboardFailure(extractError(error)));
  }
}

export function* loadClientTotalDashboardSaga(
  action: LoadClientDashboardAction
): Generator<StrictEffect, void, any> {
  const { clientId } = action.payload;
  const companyId = yield select(selectActiveCompanyId);

  try {
    const clientDashboardResponse: ExtractionSummary = yield call(
      performDataAction,
      DataType.Summary,
      "list",
      {
        clientId: clientId || companyId
      }
    );
    yield put(clientTotalDashboardSuccess(clientDashboardResponse));
  } catch (error) {
    yield put(clientTotalDashboardFailure(extractError(error)));
  }
}

export default function* ClientDashboardSaga() {
  yield takeEvery(loadClientDashboard.type, loadClientDashboardSaga);
  yield takeEvery(loadClientTotalDashboard.type, loadClientTotalDashboardSaga);
}
